import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app-sidebar";
import { SiteHeader } from "@/components/site-header";
import useGcpsUIController from "@/hooks/useGlobalContext";
import MainLayout from "./MainLayout";
import DashboardSkeleton from "@/components/DashboardSkeleton";
import ForcePasswordReset from "@/components/ForcePasswordReset";


export const DashboardLayout = ({ children, header }: { children: React.ReactNode, header?: React.ReactNode }) => {

	const { controller } = useGcpsUIController();
	const { pageTitle, pageLoading, config } = controller;

	return (
		<MainLayout>
			<SidebarProvider
				style={
					{
						"--sidebar-width": "calc(var(--spacing) * 72)",
						"--header-height": "calc(var(--spacing) * 12)",
					} as React.CSSProperties
				}
			>
				<AppSidebar variant="inset" />
				<SidebarInset>
					<SiteHeader title={pageTitle} />
					<div className="flex flex-1 flex-col">
						<div className="@container/main flex flex-1 flex-col gap-2">
							<div className="flex flex-col gap-4 py-4 px-4 md:px-10 md:gap-6 md:py-6">
								{
									pageLoading ? (
										<DashboardSkeleton />
									) : (
										<>
											<ForcePasswordReset />
											{header}
											{children}
										</>
									)
								}
							</div>
							<div className="mt-auto p-8 flex items-center flex-col gap-2 md:flex-row md:justify-between">
								<small className="text-gray-300 text-center md:text-left">&copy; {new Date().getFullYear()}  All Rights Reserved | {config?.app.name}</small>
								<small className="text-gray-300">Version {config?.app.version}</small>
							</div>
						</div>
					</div>
				</SidebarInset>
			</SidebarProvider>
		</MainLayout>
	);
};